import React, { useState } from 'react';
import api from '../api';
import toast from 'react-hot-toast';
import { FiLock, FiSave } from 'react-icons/fi';

const AdminSettings = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error('All fields are required');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }
    if (newPassword.length < 6) {
      toast.error('New password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      await api.put('/auth/change-password', { currentPassword, newPassword });
      toast.success('Password updated successfully!');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="admin-page-header">
        <h1>Settings</h1>
      </div>

      <div className="admin-form" style={{ maxWidth: '500px' }}>
        <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.2rem', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiLock size={18} /> Change Password
        </h3>

        <form onSubmit={handleChangePassword}>
          <div className="editor-field">
            <label>Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Enter current password"
            />
          </div>
          <div className="editor-field">
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />
          </div>
          <div className="editor-field">
            <label>Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />
          </div>
          <button type="submit" className="admin-btn admin-btn-primary" disabled={loading}>
            {loading ? 'Updating...' : <><FiSave size={14} /> Update Password</>}
          </button>
        </form>
      </div>

      <div className="admin-form" style={{ maxWidth: '500px', marginTop: '24px' }}>
        <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.2rem', marginBottom: '16px' }}>
          SMTP Configuration
        </h3>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: 1.7 }}>
          Email settings are configured in the server's <code style={{ background: 'var(--bg-tertiary)', padding: '2px 8px', borderRadius: '4px', fontFamily: "'JetBrains Mono', monospace", fontSize: '0.85rem' }}>.env</code> file:
        </p>
        <div style={{ marginTop: '14px', padding: '16px', background: 'var(--bg-tertiary)', borderRadius: '8px', fontFamily: "'JetBrains Mono', monospace", fontSize: '0.82rem', color: 'var(--text-secondary)', lineHeight: 1.8 }}>
          SMTP_HOST=smtp.hostinger.com<br />
          SMTP_PORT=465<br />
          SMTP_SECURE=true<br />
          SMTP_USER=contact@drnileshpanchal.com<br />
          SMTP_PASS=your_password
        </div>
      </div>

      <div className="admin-form" style={{ maxWidth: '500px', marginTop: '24px' }}>
        <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.2rem', marginBottom: '16px' }}>
          About This Panel
        </h3>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: 1.7 }}>
          This admin panel allows you to manage your portfolio website content, respond to contact messages via email, and view visitor analytics. All changes are saved to the MongoDB database and reflected on the live site immediately.
        </p>
      </div>
    </div>
  );
};

export default AdminSettings;
